"use strict";export var PaymasterMode;(function(E){E.ERC20="ERC20",E.SPONSORED="SPONSORED"})(PaymasterMode||(PaymasterMode={}));
